import axios from 'axios'

// URL base dell'API per i partecipanti, recuperato dall'env file

const PARTECIPANTE_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'partecipante'

const headers = { 'Content-Type': 'application/json' }

class PartecipanteService {

     /**
     * Recupera un partecipante specifico in base al suo ID.
     * Effettua una richiesta GET a `/partecipante/{parId}`.
     *
     * @param {number} parId - L'ID del partecipante da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli del partecipante.
     */
    getPartecipante(id) {
        return axios.get(PARTECIPANTE_REST_API_URL + `/${id}`)
    }

    // Aggiungi questo metodo nel tuo PartecipanteService.js
    findByComunePaged(comId, isAdmin, page, size) {
        // Assicurati che l'URL coincida con quello che hai impostato nel Controller Spring Boot
        return axios.get(`${PARTECIPANTE_REST_API_URL}/comune/${comId}/paged?isAdmin=${isAdmin}&page=${page}&size=${size}`);
    }

    /**
     * Effettua il login di un partecipante.
     * Effettua una richiesta GET a `/partecipante/login` con i parametri email, password e ID comune.
     *
     * @param {string} dparEmail - Email del partecipante.
     * @param {string} dparPassword - Password del partecipante.
     * @param {number} comId - ID del comune di appartenenza.
     * @returns {Promise} - Una promessa che restituisce i dati dell'utente autenticato.
     */
    login(dparEmail, dparPassword, comId) {
        return axios.post(PARTECIPANTE_REST_API_URL + `/login`, {
            dparEmail: dparEmail,
            dparPassword: dparPassword,
            comId: comId
        })
    }

    /**
     * Genera un nuovo codice OTP per un partecipante specifico.
     * Effettua una richiesta GET a `/partecipante/getNewOTP/{parId}`.
     *
     * @param {number} parId - L'ID del partecipante.
     * @returns {Promise} - Una promessa che restituisce il nuovo codice OTP.
     */
    getNewOtp(parId) {
        return axios.get(PARTECIPANTE_REST_API_URL+ `/getNewOTP/${parId}`, { headers });
      }
    
      /**
     * Verifica il codice OTP di un partecipante.
     * Effettua una richiesta GET a `/partecipante/verifyOTP/{parId}` con i parametri di verifica.
     *
     * @param {number} parId - L'ID del partecipante.
     * @param {Object} params - Parametri per la verifica dell'OTP.
     * @returns {Promise} - Una promessa che restituisce il risultato della verifica OTP.
     */
    verifyOTP(parId, params){
        return axios.get(PARTECIPANTE_REST_API_URL+`/verifyOTP/${parId}`,{
          params: params, 
          headers: headers
        });
      }

       /**
     * Recupera tutti i partecipanti di un comune specifico.
     * Effettua una richiesta GET a `/partecipante/comune/{comId}`.
     *
     * @param {number} comId - ID del comune.
     * @returns {Promise} - Una promessa che restituisce una lista di partecipanti.
     */
    findByComune(comId) {
        return axios.get(PARTECIPANTE_REST_API_URL + `/comune/${comId}`)
    }

    /**
     * Conferma un token di accesso per un partecipante.
     * Effettua una richiesta POST a `/partecipante/confermaToken/{token}`.
     *
     * @param {string} token - Token di conferma.
     * @returns {Promise} - Una promessa che indica il risultato della conferma.
     */
    confermaToken(token) {
        return axios.post(PARTECIPANTE_REST_API_URL + `/confermaToken/${token}`)
    }

  anonimizzaPartecipante(parId) {

        return axios.get(PARTECIPANTE_REST_API_URL + `/anonimizza/${parId}`)
            
    }


    /**
     * Registra un nuovo partecipante associato a un comune.
     * Effettua una richiesta POST a `/partecipante/nuovoPartecipante/{comId}`.
     *
     * @param {number} comId - ID del comune a cui associare il partecipante.
     * @param {Object} partecipante - Dati del nuovo partecipante.
     * @param {boolean} ruoFlAmministratore - Indica se il partecipante ha il ruolo di amministratore.
     * @returns {Promise} - Una promessa che restituisce il risultato della registrazione.
     */
    nuovoPartecipante(comId, partecipante, ruoFlAmministratore) {
        return axios.post(PARTECIPANTE_REST_API_URL + `/nuovoPartecipante/${comId}`,
            {
                dparCf: partecipante.dparCf,
                dparCognome: partecipante.dparCognome,
                dparDataNascita: partecipante.dparDataNascita,
                dparEmail: partecipante.dparEmail,
                dparNome: partecipante.dparNome,
                dparPhoneNumber: partecipante.dparPhoneNumber
            }, {
            params: {
                ruoFlAmministratore: ruoFlAmministratore
            }
        }
        )
    }

/**
     * Cerca un partecipante in base al suo codice fiscale.
     * Effettua una richiesta GET a `/partecipante/findByCf`.
     *
     * @param {string} dparCf - Codice fiscale del partecipante.
     * @returns {Promise} - Una promessa che restituisce i dati del partecipante.
     */
    findByCf(dparCf) {

        return axios.get(PARTECIPANTE_REST_API_URL + `/findByCf`,
            {
                params: {
                    dparCf: dparCf
                }
            })
    }

     /**
     * Recupera un partecipante utilizzando il token di accesso.
     * Effettua una richiesta GET a `/partecipante/findByTokenAccesso`.
     *
     * @param {string} dparTokenAccesso - Token di accesso del partecipante.
     * @returns {Promise} - Una promessa che restituisce i dati del partecipante.
     */
    findByTokenAccesso(dparTokenAccesso) {
        return axios.get(PARTECIPANTE_REST_API_URL + `/findByTokenAccesso`,
            {
                params: {
                    token: dparTokenAccesso
                }
            })
    }

    /**
     * Importa una lista di partecipanti tramite un file CSV.
     * Effettua una richiesta POST a `/partecipante/csv/upload/{comId}`.
     *
     * @param {number} comId - ID del comune.
     * @param {Object} partecipantiCSV - File CSV contenente i dati dei partecipanti.
     * @returns {Promise} - Una promessa che restituisce il risultato dell'importazione.
     */
    importPartecipanti(comId, partecipantiCSV) {
        return axios.post(PARTECIPANTE_REST_API_URL + `/csv/upload/${comId}`, partecipantiCSV, headers)
    }

    /**
     * Blocca o sblocca un partecipante specifico.
     * Effettua una richiesta POST a `/partecipante/blocca/{parId}` con un parametro booleano.
     *
     * @param {number} parId - L'ID del partecipante da bloccare/sbloccare.
     * @param {boolean} flag - `true` per bloccare, `false` per sbloccare.
     * @returns {Promise} - Una promessa che indica il risultato dell'operazione.
     */
    bloccaPartecipante(parId, flag) {
        return axios.post(PARTECIPANTE_REST_API_URL + `/blocca/${parId}`, null,
            {
                params: {
                    "flag": flag
                }
            })
    }

    /**
     * Cambia la password di un partecipante utilizzando un token di autenticazione.
     * Effettua una richiesta POST a `/partecipante/cambiaPassword/{token}`.
     *
     * @param {string} token - Token di autenticazione per la modifica della password.
     * @param {string} pwd - Nuova password.
     * @param {string} confermaPwd - Conferma della nuova password.
     * @returns {Promise} - Una promessa che indica il risultato dell'operazione.
     */
    cambiaPassword(token, pwd, confermaPwd){
        return axios.post(PARTECIPANTE_REST_API_URL+ `/cambiaPassword/${token}`, 
            {
                "password": pwd,
                "confermaPassword": confermaPwd
            })
    }
/**
     * Aggiorna i dati di un partecipante.
     * Effettua una richiesta POST a `/partecipante/aggiornaPartecipante`.
     *
     * @param {Object} partecipante - Dati aggiornati del partecipante.
     * @returns {Promise} - Una promessa che indica il risultato dell'operazione.
     */
    aggiornaPartecipante(partecipante) {
        return axios.post(PARTECIPANTE_REST_API_URL + "/aggiornaPartecipante", partecipante, headers)
    }


    getTotalePartecipanti = (comId) => {
        return axios.get(`${PARTECIPANTE_REST_API_URL }/totale/${comId}`);
      };


      spidInitCatania(returnOK, returnKO) {
    return axios.get(PARTECIPANTE_REST_API_URL + `/initCatania`, {
      params: { returnOK, returnKO }
    });
  }

  spidCompleteCatania(buffer) {
    return axios.get(PARTECIPANTE_REST_API_URL + `/completeCatania`, {
      params: { buffer }
    });
  }

  findByComunePaged(comId, isAdmin, page, size, search = "") {
        let url = `${PARTECIPANTE_REST_API_URL}/comune/${comId}/paged?isAdmin=${isAdmin}&page=${page}&size=${size}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return axios.get(url);
    }
      
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const partecipanteServiceInstance = new PartecipanteService()
export default partecipanteServiceInstance;
